var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictorSlideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M31 16.5001C31 8.39991 24.4335 1.83342 16.3333 1.83341C8.23316 1.83341 1.66667 8.3999 1.66667 16.5001C1.66667 24.6003 8.23316 31.1667 16.3333 31.1667C24.4335 31.1667 31 24.6003 31 16.5001Z",
    stroke: "#49A942",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M14.4142 22.1667L19.7071 16.8739C20.0976 16.4833 20.0976 15.8502 19.7071 15.4596L14.4142 10.1667",
    stroke: "#49A942",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictorSlideRight);
export default __webpack_public_path__ + "static/media/predictor-slide-right.9699d10a60857f9a11ebabe695ba1930.svg";
export { ForwardRef as ReactComponent };